import { Switch, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Toolbar, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Add, Delete } from "@mui/icons-material";
import AccountApiService from "../../../adapters/xhr/AccountApiService";
import SnackbarUtils from "../../../SnackbarUtils";
import { AddAccount } from "./AddAccount";

export const AccountManagementPage = () => {
  const { t, i18n } = useTranslation();
  const columns = [
    { id: "UserName", label: t("username"), minWidth: 170, sortable: true },
    { id: "Email", label: t("email"), minWidth: 170, sortable: true },
    { id: "Role", label: t("role"), minWidth: 170, sortable: false },
    { id: "Actions", label: t("actions"), minWidth: 170, sortable: false, align: "left" },
  ];
  const [sortBy, setSortBy] = useState("Created");
  const [ascending, setAscending] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [accounts, setAccounts] = useState([]);
  const [addAccount, setAddAccount] = useState(false);

  const handleClose = async (status) => {
    setAddAccount(false);
    if (status) await fetchAccounts();
  };

  const fetchAccounts = async () => {
    let payload = {
      pageNumber: page + 1,
      pageSize: rowsPerPage,
      ascending: ascending,
      sortBy: sortBy,
    };
    let response = await AccountApiService.getAll(payload);
    if (response?.isSuccess) {
      let data = response.data.items.map((option) => {
        let rObj = {};
        rObj["Id"] = option.id;
        rObj["UserName"] = option.userName;
        rObj["Email"] = option.email;
        rObj["Role"] = option.role;
        rObj["IsLocked"] = option.isBlocked;
        return rObj;
      });
      setAccounts(data);
      setTotalPages(response.data.totalCount);
    }
  };

  const handleSort = async (field, ascending) => {
    setSortBy(field);
    setAscending(ascending);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    fetchAccounts();
  }, [page, ascending, sortBy, rowsPerPage]);

  const toggleAccountBlocking = async (account, event) => {
    let payload = {
      userName: account["UserName"],
      blocked: event.target.checked,
    };
    account["IsLocked"] = event.target.checked;
    const response = await AccountApiService.toggleAccountBlocking(payload);
    if (response.isSuccess) {
      setAccounts([...accounts]);
      SnackbarUtils.success(t("update_block_status_success"));
    } else {
      account["IsLocked"] = !account["IsLocked"];
      SnackbarUtils.error(t("update_block_status_failed"));
    }
  };

  const onDeleteUser = async (userName) => {
    const response = await AccountApiService.deleteByUserName(userName);
    if (response?.isSuccess) {
      await fetchAccounts();
    } else {
      SnackbarUtils.error(t(response.errorMessage));
    }
  };

  return (
    <React.Fragment>
      <Toolbar>
        <Typography variant="h6" id="tableTitle" component="div">
          {t("accounts")}
          <Add className="selector margin left-1 top-0 bottom-0" onClick={() => setAddAccount(true)} />
        </Typography>
      </Toolbar>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                  {column.sortable ? (
                    <TableSortLabel active={column.id === sortBy} direction={ascending ? "asc" : "desc"} onClick={(e) => handleSort(column.id, !ascending)}>
                      {column.label}
                    </TableSortLabel>
                  ) : (
                    column.label
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {accounts.map((row, key) => {
              return (
                <TableRow hover tabIndex={-1} key={key}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    if (column.id === "Actions") {
                      return (
                        <TableCell key={column.id} align={"left"}>
                          <Delete className="selector margin top-0 bottom-0" onClick={() => onDeleteUser(row.UserName)} />
                          {/* <Switch
                            inputProps={{ "aria-label": "block-status" }}
                            onChange={(event) => toggleAccountBlocking(row, event)}
                            checked={row["IsLocked"]}
                          /> */}
                        </TableCell>
                      );
                    } else {
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number" ? column.format(value) : value}
                        </TableCell>
                      );
                    }
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination rowsPerPageOptions={[10, 25, 100]} component="div" count={totalPages} labelRowsPerPage={t("rows_per_page")} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
      {addAccount && <AddAccount open={addAccount} onClose={(status) => handleClose(status)} />}
    </React.Fragment>
  );
};
